import { GeckoEntry, RolodexEntryType } from 'types'

export interface SearchCounts {
  [key: string]: number
}

export interface SearchResult {
  entry: GeckoEntry
  relevanceScore: number
}

export interface GlobalSearchOptions {
  searchableTypes?: RolodexEntryType[]
  previewLimit?: number
  expandedLimit?: number
  debounceMs?: number
  minSearchLength?: number
}

export interface SearchFieldConfig {
  field: string
  key?: string
  weight?: number
}

export const DEFAULT_SEARCHABLE_TYPES: RolodexEntryType[] = [
  RolodexEntryType.UNIT,
  RolodexEntryType.INSPECTION,
  RolodexEntryType.JOB,
  RolodexEntryType.SYSTEM,
  RolodexEntryType.CHART,
]

export const DEFAULT_SEARCH_FIELDS: SearchFieldConfig[] = [
  { field: 'data', key: 'name', weight: 100 },
  { field: 'data', key: 'title', weight: 80 },
  { field: 'data', key: 'description', weight: 50 },
  { field: 'id', weight: 30 },
]

export const DEFAULT_SEARCH_OPTIONS: Required<GlobalSearchOptions> = {
  searchableTypes: DEFAULT_SEARCHABLE_TYPES,
  previewLimit: 10,
  expandedLimit: 50,
  debounceMs: 300,
  minSearchLength: 2,
}
